import React, { useState } from "react";
import { TableCell, TableRow } from "@mui/material";

import {
  useDeleteBranchMutation,
  useUpdateBranchMutation,
} from "../../../Service/branches";
import PermissionCheck from "../../../Component/PermissionCheck";
import AlertDialog from "../../../Component/DigitalMarketing/deleteConfirmation";
import useDeleteBox from "../../../hooks/digitalMarketing/useDeleteBox";
import edit from "../../../assets/DigitalMarketing/image/edit.svg";
import dele from "../../../assets/DigitalMarketing/image/delete.svg";

interface props {
  customer_list: any;
  getComparator: any;
  order: any;
  orderBy: string;
  handleClick: any;
  handleChange: any;
  stableSort: any;
  state: any;
  setstates: any;
  setBranchDetail: any;
}
function TableList({
  customer_list,
  getComparator,
  order,
  orderBy,
  handleClick,
  state,
  setstates,
  stableSort,
  setBranchDetail,
}: props) {
  const [deleteBranch] = useDeleteBranchMutation();
  const [updateBranch] = useUpdateBranchMutation();
  const { open, message, openDelete, deleteId } = useDeleteBox();

  const handleClicks = (branch) => {
    setBranchDetail(branch);
    setstates(!state);
  };



  const deleteBranches = async (bool) => {
    if (bool) {
      await deleteBranch(deleteId);
    }
    openDelete("Are you sure you want to delete this branch?", false, null);
  };

  return (
    <>
      <>
        <AlertDialog
          open={open}
          message={message}
          deleteBranches={deleteBranches}
        />
      </>
      {stableSort(customer_list, getComparator(order, orderBy)).map((a, i) => {
        return (
          <TableRow
            hover
            onClick={(event) => handleClick(event, a.id)}
            role="checkbox"
            tabIndex={-1}
            key={i}
          >
            <TableCell align="center">
              <div className="d-flex align-items-center">
                <div className="rounded">
                  <img
                    src={require("../../../assets/DigitalMarketing/image/3.jpg")}
                    className="rounded-circle" alt=""
                  />
                </div>
                <span
                  className="mx-2"
                  style={{ textAlign: "left", width: "200px" }}
                >
                  {a.branchName}{" "}
                </span>
              </div>
            </TableCell>
            <TableCell align="left">
           
              {a.isMainBranch == 1 ? (
                <span className="mx-2 active-tb">Active</span>
              ) : (
                <span className="mx-2 inactive-tb">Inactive</span>
              )}
            </TableCell>
            <TableCell align="left">{a.address}</TableCell>
            <TableCell align="left">{a.city}</TableCell>
            <TableCell align="left">
             
              {a.activeStatus == 1 ? (
                <span className="mx-2 active-tb">Active</span>
              ) : (
                <span className="mx-2 inactive-tb">Inactive</span>
              )}
            </TableCell>
            <TableCell align="left">
              <span style={{ width: "170px" }}>{a.emailId}</span>
            </TableCell>
            <TableCell align="left">
              <span className="blue-color">{a.pincode}</span>
            </TableCell>
            <TableCell align="left">
              <span className="blue-color">{a.state}</span>
            </TableCell>
            <TableCell align="left">
              <span className="blue-color">{a.country}</span>
            </TableCell>
            <TableCell align="left">{a.mobileNo}</TableCell>
            <TableCell align="center">
              <div className="d-flex">
                {PermissionCheck("hospital_branch", "update") && (
                  <img
                    src={edit} alt=""
                    className="blue-c action-icon cursur me-2"
                    onClick={() => {
                      handleClicks(a);
                    }}
                  />
                )}
                {PermissionCheck("hospital_branch", "delete") && (
                  <img
                    src={dele} alt=""
                    onClick={() => {
                      openDelete(
                        "Are you sure you want to delete this branch?",
                        true,
                        a.id
                      );
                    }}
                    className="delete-icon cursur action-icon"
                  />
                )}
              </div>
            </TableCell>
          </TableRow>
        );
      })}
    </>
  );
}
export default React.memo(TableList);
